import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import api from "../../config/api";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const formInit = {
  date: new Date(),
  amount: "",
  comment: "",
};
export default function RebateModel() {
  const queryClient = useQueryClient();

  const Body = ({ onDone }) => {
    const [form, setForm] = useState(cloneDeep(formInit));
    const handleChange = ({ target }) => {
      setDisabled(false);
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };
    const handleSubmit = async (event) => {
      event.preventDefault();
      setDisabled(true);
      const res = await api.post("rebate", {
        ...form,
      });
      if (!res.ok) {
        setDisabled(false);
        return toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["incomeRebates"]);

      setDisabled(false);
      toast.success("Other Income Successfully Added.");
      onDone && onDone();
    };
    const [disabled, setDisabled] = useState(false);
    return (
      <form id="form" onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <span className="d-flex" style={{ alignItems: "center" }}>
            <b>Other Incomes</b>
          </span>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex"
            style={{
              gap: "0px 30px",
              padding: "0px 30px",
              alignItems: "flex-start",
              // minHeight: 300,
            }}
          >
            <AppInput
              type="date"
              name="date"
              placeholder="Date"
              label="Date"
              floatLabel
              value={form.date}
              onChange={handleChange}
              required
            />

            <AppInput
              name="amount"
              value={numberFormat(form.amount)}
              onChange={handleChange}
              required
              label="Amount"
              floatLabel
              containerStyle={{ height: 90 }}
            />
            <AppInput
              name="comment"
              value={form.comment}
              onChange={handleChange}
              label="Comment"
              floatLabel
              containerStyle={{ height: 90 }}
            />
          </div>
          <br />
          <br />
          <br />
          <br />
        </Modal.Body>
        <Modal.Footer>
          <AppButton
            disabled={disabled}
            text="Add"
            form="form"
            type="submit"
            className="text-primary btn-light"
          />
        </Modal.Footer>
      </form>
    );
  };

  return { Body };
}
